export const aboutData = {
    title: "Who I am",
    description1: "Hey 👋🏻, Myself Sachin Dhakal. I'm a Novice Flutter Developer.",
    description2:
        `
        Welcome to the website of Sachin Dhakal, a novice Flutter developer and the founder of Dhindo Cricket Pvt. Ltd. 
        Sachin is a passionate developer who has been honing his skills in Flutter, a popular mobile app development framework. 
        With his strong foundation in programming and a keen eye for detail, Sachin has been creating impressive applications 
        that offer a seamless user experience.
    `,
    description3:
        `
        In addition to his development skills, Sachin is also an entrepreneur and the founder of Dhindo Cricket Pvt. Ltd., a company that is dedicated to promoting and developing the sport of cricket in Nepal.
         His passion for both technology and sports has driven him to make a significant impact in both fields. 
    `,
    description4:
        `
        Through this website, Sachin shares his knowledge and experience in Flutter development, as well as updates on his latest projects and ventures. 
        Whether you're a fellow developer or a cricket enthusiast, you'll find valuable insights and information here. Thank you for visiting!
    `,
    image: 2
}